import React from 'react'
import LazyLoad from 'react-lazyload'
import { Link } from 'react-router-dom'
const Erplinks = () => {
  return (
     <>
     <div className="erp_links"> <Link to="https://xavierbathinda.campuscare.info/" target="_blank">
      <LazyLoad><img src="https://webapi.entab.info/api/image/SXSBPB/public/Images/Campulogo.png" alt="St. Xaviers Bathinda" /></LazyLoad></Link>
     </div>
     </>
  )
}

export default Erplinks
